export interface AxisColors {
  x: number;
  y: number;
  z: number;
}

const LIGHT_AXES: AxisColors = { x: 0xe03131, y: 0x2f9e44, z: 0x1c7ed6 };
const DARK_AXES: AxisColors = { x: 0xff6b6b, y: 0x51cf66, z: 0x4dabf7 };

export const cssColor = (hex: number): string => `#${hex.toString(16).padStart(6, '0')}`;

export const axisColors = (isDark: boolean): AxisColors => (isDark ? DARK_AXES : LIGHT_AXES);

export const modelColor = (isDark: boolean): number => (isDark ? 0x6c6c74 : 0x8f8f98);
export const edgeColor = (isDark: boolean): number => (isDark ? 0x0c0e14 : 0x1a1e29);
export const hoverColor = (isDark: boolean): number => (isDark ? 0x66b2ff : 0x2f8cff);
export const sectionCapColor = (isDark: boolean): number => (isDark ? 0xd4b47a : 0xdfbd82);
export const measureColor = (isDark: boolean): number => (isDark ? 0xffcc4d : 0xb86e00);

export const backgroundColor = (isDark: boolean): number => (isDark ? 0x0e0f18 : 0xfbf8ff);
